import { Stack, Typography } from "@braintrust/braintrust-ui-components";
import { fetchCurrentUser } from "@js/apps/auth/actions";
import { useFreelancerId } from "@js/apps/common/hooks/use-freelancer-id";
import { useUpdateTaxFormMutation } from "@js/apps/freelancer/api";
import { Snackbar } from "@js/components/snackbar";
import { useAppDispatch } from "@js/hooks";

import { TaxDocumentOverrideButton } from "../tax-document-override-button";

import type { AddW9FormData } from "./add-w9-form";
import { AddW9Form } from "./add-w9-form";

type AddW9ModalContentProps = {
  showSwitchFormButton?: boolean;
  closeModal: () => void;
};

export const AddW9ModalContent = ({
  closeModal,
  showSwitchFormButton,
}: AddW9ModalContentProps) => {
  const dispatch = useAppDispatch();
  const freelancerId = useFreelancerId();
  const [updateTaxForm] = useUpdateTaxFormMutation();

  const onSubmit = (values: AddW9FormData) => {
    if (!freelancerId) {
      return;
    }

    return updateTaxForm({
      freelancerId,
      formType: "w9",
      formFileId: values.w9_form,
    }).then(() => {
      dispatch(fetchCurrentUser()).catch(() => null);

      closeModal();
      Snackbar.success(`Saved Successfully.`);
    });
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          mb: "30px",
          gap: 1,
        }}
      >
        <Typography
          component="h3"
          variant="title"
          fontWeight={400}
          size="small"
        >
          W-9 Form
        </Typography>
        {showSwitchFormButton && (
          <TaxDocumentOverrideButton formType={ENUMS.TaxForm.W9_FORM} />
        )}
      </Stack>

      <Typography component="p" sx={{ mb: 1 }}>
        Upload a completed W-9. In case of an error, the newest form uploaded
        will be used by Braintrust.
      </Typography>
      <AddW9Form onSubmit={onSubmit} onClose={closeModal} />
    </>
  );
};
